import * as PricelistModels from '../../models/pricelist/pricelist';
import { PricelistSearchModel } from '../../models/pricelist/pricelistSearch';
import * as Models from '../../models/commonModels';

export class GetPricelistTypeDictionary {
  static readonly type = '[Pricelist ] GetPricelistTypeDictionary';
  constructor() { }
}

export class Get {
  static readonly type = '[Pricelist] Get';
  constructor(public PriceListId: Models.RequestModel) { }
}

export class GetList {
  static readonly type = '[Pricelist] GetList';
  constructor(public Search: PricelistSearchModel) { }
}

export class Set {
  static readonly type = '[Pricelist] Set';
  constructor(public Pricelist: Models.Request<PricelistModels.PricelistModel>) { }
}

export class ResetSave {
  static readonly type = '[Pricelist] ResetSave';
  constructor() { }
}

export class SetSearch {
  static readonly type = '[Pricelist] SetSearch';
  constructor(public Search: PricelistSearchModel) { }
}

export class SetListPage {
  static readonly type = '[Pricelist] SetListPage';
  constructor(public Search: PricelistSearchModel) { }
}
